<script lang="ts" setup>
import { SwiperSlide } from 'swiper/vue'
import { useStoreConfig } from '~/store/storeConfig'
import { useCategoryStore } from '~/store/categoryStore'
import type { CategoryItem, Product } from '~/types/searchTypes'
import { fetchRetryParameters, requestHostHeaders, type RequestHostHeadersType } from '~/composables/constants/api'

const props = defineProps<{
  backgroundColor?: string
}>()
const config = useStoreConfig()
const categoryStore = useCategoryStore()
const locale = useState<string>('locale.setting')

const products = ref<Product[]>([])

watch(
  (): [string, CategoryItem[]] => [config.queryKeys?.itemsDocKey ?? '', categoryStore.getCategoryTree],
  async ([itemDocKey, categories]) => {
    try {
      if (categories.length && itemDocKey) {
        products.value = await $fetch('/api/hooks/categoryMostPopularProducts', {
          method: 'POST',
          body: {
            locale: locale.value,
            queryKey: itemDocKey,
            categories,
          },
          ...fetchRetryParameters,
          timeout: 5000,
          headers: useRequestHeaders<RequestHostHeadersType>(requestHostHeaders),
        })
      }
    } catch (error) {}
  },
  {
    immediate: true,
  }
)
</script>

<template>
  <section
    v-if="Boolean(products.length)"
    :style="{
      backgroundColor: props.backgroundColor,
    }">
    <FullSlider>
      <template #sliderContent>
        <SwiperSlide v-for="(product, index) in products" :key="index">
          <CategoryProductCard :product="product" />
        </SwiperSlide>
      </template>
    </FullSlider>
  </section>
</template>
